<template>
    <div id="DownloadCenter">
    <view1/>
    <view2/>

    </div>

</template>
<script>
    export default {
        name: 'DownloadCenter',
        components: {
            // 异步加载子组件
            view1: () => import('@/views/DownloadCenter/view1.vue'),
            view2: () => import('@/views/DownloadCenter/view2.vue')
        }
    }
</script>
<style scoped>

</style>